export default {
  SET_ITEMS(state, items) {
    state.items = items || []
  },
  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = Number(count) || 0
  },
  SET_DEFAULT_GURUDWARA_ID(state, id) {
    state.defaultGurudwaraId = id || null
  },
  SET_LOADING(state, loading) {
    state.loading = !!loading
  },
  SET_QUICK_COUNTS(state, counts) {
    state.quickCounts = {
      prasad: Number((counts && counts.prasad) || 0),
      sarai: Number((counts && counts.sarai) || 0),
      hotel: Number((counts && counts.hotel) || 0),
      anandKaraj: Number((counts && counts.anandKaraj) || 0),
      service: Number((counts && counts.service) || 0)
    }
  },
  MARK_ITEM_READ(state, id) {
    const item = state.items.find((notification) => notification._id === id)
    if (item && !item.is_read) {
      item.is_read = true
      state.unreadCount = Math.max(0, state.unreadCount - 1)
    }
  },
  MARK_ALL_READ(state) {
    state.items = (state.items || []).map((notification) => (
      notification.is_read ? notification : { ...notification, is_read: true }
    ))
    state.unreadCount = 0
  }
}
